import React from 'react';
import LoaderComponent from 'features/shared/Loader';
import { CardsWrapper, HeaderPriorityProjects, Plate } from './PriorytyProjectsStyled';
import usePriorityProjectsStore from './usePriorityProjectsStore';
import { ReactComponent as StarIcon } from './images/star.svg';
import PriorityProjectCard from './components/PriorityProjectCard/PriorityProjectCard';
import { PriorityProject } from './model';
import InformModal from './components/InformModal/InformModal';
import { useClickStreamContext } from 'features/shared/ClickStream';

const PriorityProjects = ({ store }: { store: ReturnType<typeof usePriorityProjectsStore> }) => {
  const clickStream = useClickStreamContext()
  const handleInformClick = (project: PriorityProject) => {
    store.setIsInformModalOpen(true);
    store.setSelectedProject(project);

    clickStream.logPageEvent({
      eventType: 'priority-project-inform-button-click',
      eventInfo: 'Клик по кнопке "Проинформировать"',
      cd1: project.title
    })
  };

  if (store.pending)
    return (
      <Plate>
        <LoaderComponent color={'#825AF7'} />{' '}
      </Plate>
    );

  return (
    <Plate>
      <HeaderPriorityProjects>
        <StarIcon /> <span style={{ marginLeft: '6px' }}>Приоритетные проекты региона</span>
      </HeaderPriorityProjects>

      <CardsWrapper>
        {store.priorityProjects.map((project, index) => (
          <PriorityProjectCard key={index} priorityProject={project} onInformClick={() => handleInformClick(project)} />
        ))}
      </CardsWrapper>

      {store.isInformModalOpen && store.selectedProject && store.selectedProject.inform_message && (
        <InformModal
          onClose={() => store.setIsInformModalOpen(false)}
          title={store.selectedProject.title}
          text={store.selectedProject.inform_message}
        />
      )}
    </Plate>
  );
};

export default PriorityProjects;
